module.exports = __webpack_public_path__ + "img/hr-diesel-locomotive-6.c5fbbbb1.png";